import React, { Component } from 'react';

import { SectionTitle, BoxContentBlog }  from '../../helpers/section';
import { isMobile } from 'react-device-detect';

const posts = [
    {col: 'col-12 col-md-6 col-lg-6', img:'sample-blog', title: 'Titulo do Artigo postado', date: '2019-03-16', comments: 5, category: 'Notícias'},
    {col: 'col-12 col-md-6 col-lg-6', img:'sample-blog', title: 'Titulo do Artigo postado', date: '2019-03-09', comments: 5, category: 'Dicas'},
    {col: 'col-12 col-md-6 col-lg-6', img:'sample-blog', title: 'Titulo do Artigo postado', date: '2019-02-14', comments: 5, category: 'Notícias'},
    {col: 'col-12 col-md-6 col-lg-6', img:'sample-blog', title: 'Titulo do Artigo postado', date: '2019-01-16', comments: 5, category: 'Dicas'},    
];

class Blog extends Component {
    render() {
        return (
            <section className={isMobile ? 'home-blog-mobile' : 'home-blog'}>
                <div className="container">
                    {SectionTitle({section: 'Blog', subtitle:'DICAS, NOTÍCIAS E MUITO', featured: 'MATERIAL RICO'})}
                    <div className="row">
                        {posts.map((item,key) => { return BoxContentBlog(item,key) } )}
                    </div>                 
                </div>
            </section>
        )
    }
}

export default Blog;
